export default "__VITE_ASSET__Cha$Vbis__"